export default __webpack_public_path__ + "cd331c54132f9c074e9bb8ca564adcfd.webp";